export default {"src":"/_next/static/media/marie-claire.4b9c6bff.svg","height":16,"width":108,"blurWidth":0,"blurHeight":0};